<form novalidate class="user-settings-form-container cf-flex-column cf-gap-20" [formGroup]="userSettingsForm" (submit)="onSave()">
  <app-entity-editor
    *ngIf="userSettingsEntity"
    class="cf-fill"
    [entity]="userSettingsEntity"
    [entityForm]="userSettingsForm"
    (propertyChange)="propertyChange($event)"
  ></app-entity-editor>

  <div class="cf-flex-row cf-gap-24 property-layout">
    <div class="form-button">
      <button type="submit" data-test="SaveButton" mat-flat-button color="primary" [disabled]="messages.length > 0">
        {{ 'UI.Common.Action.Save' | translate }}
      </button>
    </div>

    <div class="form-button">
      <a routerLink="/projects">
        <button type="button" data-test="LinkToHomepage" mat-stroked-button>{{ 'UI.Common.GoToProjects' | translate }}</button>
      </a>
    </div>
  </div>
</form>
